// EL PIE LEGAL DE LAS PANTALLAS PÚBLICAS (5-nov-2026, el banco del TPV virtual).
//
// El banco del TPV virtual con el que Biango cobra a las clínicas pide que la página de entrada (biango.app/login)
// lleve abajo los enlaces legales. Solo los enlaces, discretos: el titular, sus datos y las condiciones están DENTRO del
// aviso legal de biango.es (el dueño: «todo eso va dentro de aviso legal»). Se abren en otra pestaña. La página de pago del PACIENTE no lo lleva: allí
// cobra cada clínica, y lo legal que cuenta es el de esa clínica.
import { t as i18nT } from '../utils/i18n'

const WEB = 'https://biango.es'

export default function PieLegal({ style = null }) {
  const ir = { target: '_blank', rel: 'noopener noreferrer', style: { color: 'inherit', textDecoration: 'none' } }
  return (
    <nav data-pie-legal="" aria-label={i18nT('components.PieLegal.informacion_legal', 'Información legal')}
      style={{ marginTop: 18, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '4px 14px', fontSize: 11.5, color: 'var(--text-muted, #8a8f98)', ...(style || {}) }}>
      <a href={WEB + '/aviso-legal/'} {...ir}>{i18nT('components.PieLegal.aviso_legal', 'Aviso legal')}</a>
      <a href={WEB + '/privacidad/'} {...ir}>{i18nT('components.PieLegal.privacidad', 'Privacidad')}</a>
      <a href={WEB + '/cookies/'} {...ir}>{i18nT('components.PieLegal.cookies', 'Cookies')}</a>
    </nav>
  )
}
